export default {
    button: {
        primary: {
            base: 'border border-transparent',
            active: 'text-white bg-green  ',
            disabled: 'cursor-not-allowed text-grayDark bg-gray-200',
        },
        outline: {
            base: 'bg-white text-green border-green border ',
            active: '',
            disabled: 'cursor-not-allowed text-grayDark bg-gray-200',
        },
        link: {
            base: 'bg-white text-green',
            active: '',
            disabled: 'cursor-not-allowed text-grayDark bg-gray',
        },
        size: {
            larger: 'px-16 py-46 rounded-3xl',
            large: 'px-9 py-3 rounded-3xl',
            regular: 'px-8 py-2 rounded-3xl text-sm',
            small: 'px-4 py-1 rounded-3xl text-xsm',
            icon: {
                larger: 'p-4 rounded-3xl',
                large: 'p-3 rounded-3xl',
                regular: 'p-2 rounded-3xl',
                small: 'px-4 py-2 rounded-3xl',
            },
            pagination: 'px-5 py-1 rounded-3xl text-xs m-1',
        },

    },
    input: {
        base: 'block w-full text-xs focus:outline-none  focus:border-green border border-green dark:text-gray-300 leading-4 rounded-lg  p-3',
        active: '',
        checkbox:
            'text-gray   form-checkbox  focus:border-green focus:outline-none focus:ring-green focus:border-green focus:ring-offset-0 rounded dark:focus:ring-green',
    },
    label: {
        base: 'block text-xs text-midnight dark:text-gray-400 whitespace-nowrap flex items-center ',
        check: 'inline-flex items-center',
        disabled: 'opacity-50 cursor-not-allowed',
    },
    card: {
        base: 'min-w-0 rounded-lg  overflow-hidden border  ',
        default: 'bg-white dark:bg-gray-800',
    },
    select: {
        base: 'block w-full text-xs  focus:outline-none  focus:border-green  text-gray-500 leading-4 rounded-lg p-3 border border-green md:mt-2 ',
        active: '',
        select: '',

    },
    textarea: {
        base: 'block w-full text-xs focus:outline-none focus:border-green border-green dark:text-green-300 focus:ring-green  focus:ring-offset-0 leading-4 rounded-xl ',
        active: '',

    },



    // ModalHeader
    modalHeader: {
        base: ' pb-2 border-b border-midnight-light text-sm font-semibold text-midnight-dark dark:text-gray-300',
    },
    dropdown: {
        base:
            'absolute w-56 p-2 mt-2 text-gray-600 bg-white border border-gray-100 rounded-lg shadow-md min-w-max-content dark:text-gray-300 dark:border-gray-700 dark:bg-gray-700',
        align: {
            left: 'start-0',
            right: 'end-0',
        },
    },

    // Avatar
    avatar: {
        base: 'relative rounded-full inline-block',
        size: {
            large: 'w-16 h-16',
            regular: 'w-8 h-8',
            small: 'w-6 h-6',
        },
    },

    cardBody: {
        base: 'p-4',
    },
    tableBody: {
        base: 'divide-grayLight divide-y-8 rounded-full'
    },
    // TableContainer
    tableContainer: {
        base: 'w-full overflow-hidden ',
    },
    tableHeader: {

        base: "border-0"
    },

    tableRow: {
        base: 'bg-white',
    },
    tableCell: {
        base: 'text-grayDark p-3  text-xs'
    },
    pagination: {
        base: "flex flex-col text-xs justify-end text-gray-600 dark:text-gray-400 sm:flex-row-reverse overflow-x-auto",
        goto:'flex justify-items-center items-center mx-5 flex-row-reverse',
    },
    // TableFooter
    tableFooter: {
        base:
            'px-4 py-3  text-gray-500  rounded-3xl bg-white mt-2',
    },
    alert: {
        base: 'p-4 pl-12 relative rounded-lg leading-5',
        withClose: 'pr-12',
    }
}
